export default fullName => {
  const loginEvent = new CustomEvent('profileNameChanged', {
    detail: {
      fullName,
    }
  });
  document.dispatchEvent(loginEvent);
};
